import { Fragment as e, jsx as t } from "react/jsx-runtime";
//#region src/components/applicationHeader/AppMenuContent.tsx
var n = (n) => {
	let { appMenuItems: r, appNavigator: i } = n;
	return i ? /* @__PURE__ */ t("li", {
		role: "presentation",
		children: i
	}, "app-navigator") : /* @__PURE__ */ t(e, { children: r.map((e) => /* @__PURE__ */ t("li", {
		role: "presentation",
		children: e.route
	}, `link-icon-${e.key}`)) });
};
//#endregion
export { n as default };

//# sourceMappingURL=AppMenuContent.js.map